<!-- 发起弹窗 -->
<template>
  <div>
    <el-dialog
      title="充值"
      :visible="isShowRechargeDialog"
      width="40%"
      :close-on-click-modal="false"
      @close="handleDialog"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="充值币种" prop="fromCurrency">
            <el-select
              v-model="form.fromCurrency"
              placeholder="请选择"
              size="small"
            >
            <el-option v-if="domain == 'api.pay-pakistan.com'" label="PKR" value="PKR"></el-option>
            <el-option label="USDT" value="USDT"></el-option>
            </el-select>
          </el-form-item>

        <el-form-item label="充值金额" prop="amount" v-if="form.fromCurrency=='BRL'">
          <el-input
            size="small"
            type="text"
            v-model="form.amount"
            placeholder="请输入充值金额"
          ></el-input>
        </el-form-item>

        <el-form-item label="充币数量" prop="fromAmount" v-if="form.fromCurrency=='USDT'">
          <el-input
            size="small"
            type="text"
            style="width: 200px" 
            v-model="form.fromAmount"
            placeholder="请输入充币数量"
          ></el-input>
        </el-form-item>

        <el-form-item label="交易号" prop="txId">
          <el-input
            size="small"
            type="text"
            v-model="form.txId"
            placeholder="请输入64位交易号/Hash/区块id,以加快审批"
            show-word-limit maxlength="150"
          ></el-input>
        </el-form-item>

        <el-form-item label="接收账号" prop="collectAccount">
          <el-input
            size="small"
            type="text"
            v-model="form.collectAccount"
            placeholder="请输入42位接收账号"
            show-word-limit maxlength="42"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            size="small"
            type="textarea"
            v-model="form.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShowRechargeDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        type: '00',
        amount: '',
        fromAmount:'',
        txId:'',
        collectAccount: 'TAarigwYhT6t7BEmyhZ4X7e9jCXasAdkbG',
        remark: '',
        fromCurrency:'USDT'
      },
      rules: {
        fromCurrency: [
          { required: true, message: '请选择充值类型', trigger: 'change' },
        ],
        amount: [
          { required: true, message: '请输入充值金额', trigger: 'blur' },
        ],
        fromAmount: [
          { required: true, message: '请输入充币数量', trigger: 'blur' },
        ],
        txId: [
          {max: 150, message: '请输入64位交易号', trigger: 'blur' },
        ],
        collectAccount: [
          { required: true, message: '请输入42位账号', trigger: 'blur' },
          { min: 34, max: 42, message: '请输入42位账号', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    handleDialog() {
      this.$refs['form'].resetFields()
      this.form = {
        type: '00',
        amount: '',
        fromAmount:'',
        txId:'',
        collectAccount: 'TAarigwYhT6t7BEmyhZ4X7e9jCXasAdkbG',
        remark: '',
        fromCurrency:'USDT'
      }
      this.$emit('update:isShowRechargeDialog', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let params = {}
          if(this.form.fromCurrency=='BRL'){
            params={
              type:this.form.type,
              amount:this.form.amount,
              collectAccount:this.form.collectAccount,
              remark:this.form.remark,
              fromCurrency:this.form.fromCurrency
            }
          }else{
            params={
              type:this.form.type,
              fromAmount:this.form.fromAmount,
              txId:this.form.txId,
              collectAccount:this.form.collectAccount,
              remark:this.form.remark,
              fromCurrency:this.form.fromCurrency
            }
          }
          this.$axios
            .post('/depositWithdraw/addDepositWithdraw', params)
            .then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success',
                })
                this.$emit('update:isShowRechargeDialog', false)
                this.$bus.$emit('refresh') //通知刷新
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg,
                })
              }
            })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>